import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useOutletContext } from "react-router-dom";
import { Nav, Tab } from "react-bootstrap";
import FormHeader from "Views/Private/FormBuilder/FormHeader";
import { GeneralSettings, JobSettings, StartEndScreen } from "..";

export const FormSettings = () => {
  const { t } = useTranslation();
  const { formDetails } = useOutletContext();

  const [activeSettings, setActiveSettings] = useState("generalSettings");

  return (
    <Tab.Container
      id="formsetting-tabs"
      defaultActiveKey="generalSettings"
      activeKey={activeSettings}
      onSelect={(key) => setActiveSettings(key)}
    >
      <FormHeader rcvForm={() => {}} dataForm={[]} existing={[]} flag={false} />
      <div className="d-flex flex-wrap rounded-bottom overflow-auto align-items-start bg-white rounded-bottom-3 formbuilder-body">
        <Nav className="formeditor-sidebar sidebar-left p-3 bg-white border-end global-tab flex-column form-setting-nav sticky-top z-1">
          <Nav.Item>
            <Nav.Link eventKey="generalSettings">
              {t("common.button.generalSettings")}
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="startendScreen">
              {t("common.button.startEndScreen")}
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="emailSettings">
              {t("common.button.emailSettings")}
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="userCollaboration">
              {t("common.button.userCollaboration")}
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="appIntegration">
              {t("common.button.appIntegration")}
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="jobSettings">
              {t("common.button.jobSettings")}
            </Nav.Link>
          </Nav.Item>
        </Nav>

        <Tab.Content className="formeditor-view ms-auto sidebar-right p-3">
          <Tab.Pane eventKey="generalSettings">
            <GeneralSettings formDetails={formDetails} />
          </Tab.Pane>
          <Tab.Pane eventKey="startendScreen">
            <StartEndScreen formDetails={formDetails} />
          </Tab.Pane>
          <Tab.Pane eventKey="emailSettings">
            {t("common.button.emailSettings")}
          </Tab.Pane>
          <Tab.Pane eventKey="userCollaboration">
            {t("common.button.userCollaboration")}
          </Tab.Pane>
          <Tab.Pane eventKey="appIntegration">
            {t("common.button.appIntegration")}
          </Tab.Pane>
          <Tab.Pane eventKey="jobSettings">
            <JobSettings formDetails={formDetails} />
          </Tab.Pane>
        </Tab.Content>
      </div>
    </Tab.Container>
  );
};
